import { Component, OnInit, HostListener, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { OrderStatus } from '../../constants/KRollConstants';
import { RouteConstants } from '../../constants/RouteConstants';
import { KRollService } from '../../services/api-services/kroll.service';
import { FormService } from '../../services/form.service';
import { UtilityService } from '../../services/utility.service';
import { environment } from 'src/environments/environment';
import { HelperService } from 'src/app/core/services/helper.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {

  @ViewChildren('drawer') drawer: any;
  dynamicMode: any;
  isDrawerOpen: boolean = true;
  OrderStatus = OrderStatus;
  tenant: any = localStorage.getItem('tenant')
  public backgroudColor = 'white';
  public color = 'black';
  public logoUrl = '/assets/images/Pillway_Your-Modern-Pharmacy.png';

  filter:any = '';
  hideForPl = false;
  hideForslqc= false;
  selectedServerLocationId: any;
  emailAllowed: any = JSON.parse(localStorage.getItem('userObj') || '{}').admin?.email;
  constructor(public RouteConstants: RouteConstants,
    public krollService: KRollService,
    public formService: FormService,
    public helperService: HelperService,
    public router: Router
  ) {
    this.selectedServerLocationId = this.helperService.getServerLocation();
    this.isDrawerOpen = true;
    this.setDrawerConfigs();
    if (this.tenant == 'pl') {
      this.hideForPl = true;
    }
    if (this.tenant == 'sl' || 'qc' || 'wylo') {
      this.hideForslqc = true;
    }
    if (this.tenant == 'wylo') {
      this.hideForPl = true;
    }
  }

  ngOnInit(): void {
    if (this.tenant == 'sl') {
      this.backgroudColor = '#304E80';
      this.color = 'white !important';
      this.filter = 'grayscale(100%) brightness(0) invert(1)';
      this.logoUrl = '/assets/images/Pillway_Your-Modern-Pharmacy.png';
    }
    if (this.tenant == 'qc') {
      this.backgroudColor = '#304E80';
      this.color = 'white !important';
      this.filter = 'grayscale(100%) brightness(0) invert(1)';
      this.logoUrl = '/assets/images/Pillway_Your-Modern-Pharmacy.png';
    }
    if (this.tenant == 'wylo') {
      this.backgroudColor = '#082E3A';
      this.color = '#FFFEF0 !important';
      //this.filter = 'grayscale(100%) brightness(0) invert(1)';
      this.logoUrl = 'assets/images/wylo-logo.svg';
    }
    if (this.tenant == 'ml') {
      this.backgroudColor = '#06874E';
      this.color = 'white !important';
      //this.filter = 'grayscale(100%) brightness(0) invert(1)';
      this.logoUrl = '/assets/images/Pillway_Your-Modern-PharmacyTitan.png';
    }
    if (this.tenant == 'ml_qc') {
      this.backgroudColor = '#06874E';
      this.color = 'white !important';
      //this.filter = 'grayscale(100%) brightness(0) invert(1)';
      this.logoUrl = '/assets/images/Pillway_Your-Modern-PharmacyTitan.png';
    }
    if (window.innerWidth >= 992) {
      this.dynamicMode = 'side';
    }
  }

  isLinkActive(url: any): boolean {
    const queryParamsIndex = this.router.url.indexOf('?');
    const baseUrl = queryParamsIndex === -1 ? this.router.url : this.router.url.slice(0, queryParamsIndex);
    return baseUrl === url;
  }
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.setDrawerConfigs();
  }
  /**
* @name setDrawerConfig
* @desc Sets drawer configuration as per
* meta detected
* @return {void}
*/
  setDrawerConfigs(): void {
    if (window.innerWidth <= 1170) {
      this.isDrawerOpen = false;
      this.dynamicMode = 'over';
    } else {
      this.dynamicMode = 'side';
    }
  }

  ngAfterViewInit(): void {
    // set Drawer and current drawer
    UtilityService.DRAWER_REF = this.drawer.first;
  }
  closeDrawer() {
    if (window.innerWidth < 1171) {
      UtilityService.DRAWER_REF.toggle();
    }
  }
}
